import { useQuery } from "@tanstack/react-query";
import { vacancyStatusTemplateService } from "@/services/vacancyStatusTemplateService";

export const useVacancyStatusTemplates = () => {
  return useQuery({
    queryKey: ["vacancy-status-templates"],
    queryFn: () => vacancyStatusTemplateService.getAllTemplates(),
  });
};

export const useVacancyStatusTemplateById = (templateId, options = {}) => {
  return useQuery({
    queryKey: ["vacancy-status-templates", templateId],
    queryFn: () => vacancyStatusTemplateService.getTemplateById(templateId),
    enabled: !!templateId && options.enabled !== false,
    ...options,
  });
};

